import Vue from 'vue'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts';
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';


import HighchartsTheme from '../config/highcharts-theme';
import HighchartsGlobalSettings from '../config/highcharts-global-settings';

import { Tab1Chart1 } from './charts/tab1-general/tab1-chart1';
import { Tab1Chart2 } from './charts/tab1-general/tab1-chart2';
import { Tab1Chart3 } from './charts/tab1-general/tab1-chart3';
import { Tab1Chart4 } from './charts/tab1-general/tab1-chart4';
import { Tab2Chart1 } from './charts/tab2-developed/tab2-chart1';
import { Tab2Chart2 } from './charts/tab2-developed/tab2-chart2';
import { Tab2Chart3 } from './charts/tab2-developed/tab2-chart3';
import { Tab2Chart4 } from './charts/tab2-developed/tab2-chart4';
import { Tab2Chart5 } from './charts/tab2-developed/tab2-chart5';
import { Tab2Chart6 } from './charts/tab2-developed/tab2-chart6';
import { Tab3Chart1 } from './charts/tab3-forests/tab3-chart1';
import { Tab3Chart2 } from './charts/tab3-forests/tab3-chart2';
import { Tab3Chart3 } from './charts/tab3-forests/tab3-chart3';
import { Tab3Chart4 } from './charts/tab3-forests/tab3-chart4';
import { Tab3Chart5 } from './charts/tab3-forests/tab3-chart5';
import { Tab3Chart6 } from './charts/tab3-forests/tab3-chart6';
import { Tab4Chart1 } from './charts/tab4-wetlands/tab4-chart1';
import { Tab4Chart2 } from './charts/tab4-wetlands/tab4-chart2';
import { Tab4Chart3 } from './charts/tab4-wetlands/tab4-chart3';
import { Tab4Chart4 } from './charts/tab4-wetlands/tab4-chart4';
import { Tab4Chart5 } from './charts/tab4-wetlands/tab4-chart5';
import { Tab4Chart6 } from './charts/tab4-wetlands/tab4-chart6';
import { Tab5Chart1 } from './charts/tab5-agriculture/tab5-chart1';
import { Tab5Chart2 } from './charts/tab5-agriculture/tab5-chart2';
import { Tab5Chart3 } from './charts/tab5-agriculture/tab5-chart3';
import { Tab5Chart4 } from './charts/tab5-agriculture/tab5-chart4';

export class ChartsService {
    constructor(options) {
        this.options = options || {};

        // Register Highcharts-vue lib with vue.js
        Vue.use(HighchartsVue)

        //Set app-wide Highcharts Options
        HighchartsMore(Highcharts);
        HighchartsSolidGauge(Highcharts);
        Highcharts.setOptions(HighchartsTheme);
        Highcharts.setOptions(HighchartsGlobalSettings);

        //Tab1
        new Tab1Chart1().initialize();
        new Tab1Chart2().initialize();
        new Tab1Chart3().initialize();
        new Tab1Chart4().initialize();
        //Tab2
        new Tab2Chart1().initialize();
        new Tab2Chart2().initialize();
        new Tab2Chart3().initialize();
        new Tab2Chart4().initialize();
        new Tab2Chart5().initialize();
        new Tab2Chart6().initialize();
        // //Tab 3
        new Tab3Chart1().initialize();
        new Tab3Chart2().initialize();
        new Tab3Chart3().initialize();
        new Tab3Chart4().initialize();
        new Tab3Chart5().initialize();
        new Tab3Chart6().initialize();
        // //Tab 4
        new Tab4Chart1().initialize();
        new Tab4Chart2().initialize();
        new Tab4Chart3().initialize();
        new Tab4Chart4().initialize();
        new Tab4Chart5().initialize();
        new Tab4Chart6().initialize();
        // //Tab 5
        new Tab5Chart1().initialize();
        new Tab5Chart2().initialize();
        new Tab5Chart3().initialize();
        new Tab5Chart4().initialize();
    }
}